import {
  HpStatsDynamicZoneModel,
  HpStatsVariant,
} from "@models/strapi-components/hp-stats";
import React from "react";
import useIcons from "@hooks/use-source-icons";
import { IconWrapper } from "@components/common/Base/StyledComponents/IconWrapper";
import { motion } from "framer-motion";
import Title from "@components/common/Title";
import { hexToRGB } from "@utils/common";
import { twMerge } from "tailwind-merge";
import { TitleHomeV2 } from "@components/Home/components/TitleHomeV2";
import { TitleHomeV2Variant } from "@components/Home/components/TitleHomeV2/types";
export interface HpStatsProps {
  componentData: HpStatsDynamicZoneModel;
}

const variantClasses: Record<HpStatsVariant, Record<string, string>> = {
  [HpStatsVariant.HOME]: {
    wrapperClassName: "flex flex-col items-center lg:gap-9",
    titleAndImageWrapperClassName:
      "col-span-4 xl:pl-[55px] pr-[76px] h-full flex items-center",
    titleWrapperClassName: " relative mb-8 xl:mb-0",
    titleClassName:
      "text-left xl:max-w-[611px] xl:leading-[60px] xl:text-[50px] font-medium",
    tileClassName: "lg:max-w-[300px]",
  },
  [HpStatsVariant.OTHER]: {
    wrapperClassName: "px-8 py-12 md:py-[60px] xl:py-20 xl:px-[140px]",
    titleAndImageWrapperClassName: "",
    titleWrapperClassName: "",
    titleClassName:
      "text-center mx-auto text-dark-purple-50 text-2xl font-semibold leading-[32px] xl:text-4xl xl:leading-[48px] mb-3 xl:mb-4",
    tileClassName: "",
  },
};

const HpStats: React.FunctionComponent<HpStatsProps> = ({ componentData }) => {
  const { title, titles: tiles, variant = HpStatsVariant.HOME } = componentData;
  const { getFromReactIcons } = useIcons();
  const {
    wrapperClassName,
    titleClassName,
    titleWrapperClassName,
    titleAndImageWrapperClassName,
    tileClassName,
  } = variantClasses[variant];

  const renderIcons = (
    iconName: string = "CustomAiPerson",
    iconFillColor?: string
  ) => {
    const Icon = getFromReactIcons(iconName);
    if (Icon) {
      return (
        <IconWrapper fillColor={iconFillColor}>
          <Icon size={32} className="w-6 xl:w-[32px]" />
        </IconWrapper>
      );
    }
  };
  return (
    <motion.div className={wrapperClassName}>
      <div className={titleAndImageWrapperClassName}>
        <motion.div className={titleWrapperClassName}>
          {variant === HpStatsVariant.HOME ? (
            <TitleHomeV2 variant={TitleHomeV2Variant.H2}>{title}</TitleHomeV2>
          ) : (
            <Title
              titleText={title ?? ""}
              variant="h2"
              className={titleClassName}
            />
          )}
        </motion.div>
      </div>
      <div className="col-span-6 grid grid-cols-2 md:grid-cols-3 grid-rows-2 gap-4 xl:gap-10 2xl:gap-12 3xl:gap-20">
        {tiles?.map((oneTile) => {
          return (
            <motion.div
              key={oneTile.subTitle}
              className={twMerge(
                "relative rounded-3xl  xl:w-auto hp-stat py-5 pl-5 pr-10",
                tileClassName
              )}
              style={{
                backgroundColor: hexToRGB(oneTile?.color ?? "#FFFFFF", 0.05),
              }}
            >
              <span className="block mb-3">
                {renderIcons(oneTile?.icon, oneTile?.color)}
              </span>
              <span className="text-2xl xl:text-[40px] 3xl:text-[40px] font-bold block">
                {oneTile.title}
              </span>
              <span className="text-base block 2xl:text-xl pb-6 mt-2">
                {oneTile.subTitle}
              </span>
            </motion.div>
          );
        })}
      </div>
    </motion.div>
  );
};
export default HpStats;
